export interface RowContent {
    text: string
}
export interface PriceTableContent {
    category: string
    title?: string
    price: string
    priceSubScript?: string
    rows: RowContent[]
    isAvailable: boolean
    popular?: string
}

export const priceTableData: PriceTableContent[] = [
    {
        category: "Simple Return",
        title: "Simple return for employment income only.",
        price: "£49",
        priceSubScript: "Perfect if you're fully employed with no self-employment or rental income.",
        rows: [
            { text: "HMRC-recognised PAYE return" },
            { text: "Full calculation of your tax bill for you to review and approve" },
            { text: "Instant submission to HMRC" },
            { text: "TaxZap fee can be claimed as an expense next year" },
            { text: "Review by an accountant" },
        ],
        isAvailable: true,
    },
    {
        popular: "MOST POPULAR",
        category: "Self-Employed Return",
        title: "For self-employment businesses, CIS, or rental income (one source only).",
        price: "£89",
        rows: [
            { text: "HMRC-recognised tax return" },
            { text: "Full calculation of your tax bill for you to review and approve" },
            { text: "Instant submission to HMRC" },
            { text: "TaxZap fee can be claimed as an expense next year" },
            { text: "Review by an accountant" },
        ],
        isAvailable: true,
    },
    {
        category: "Standard Return",
        title: "For multiple income sources.",
        price: "£159",
        rows: [
            { text: "HMRC-recognised tax return" },
            { text: "Full calculation of your tax bill for you to review and approve" },
            { text: "Instant submission to HMRC" },
            { text: "TaxZap fee can be claimed as an expense next year" },
            { text: "Review by an accountant" },
        ],
        isAvailable: true,
    },
    {
        category: "Reviewed Return",
        title: "Standard return plus an accredited accountant's review for added peace of mind.",
        price: "£220",
        rows: [
            { text: "HMRC-recognised tax return" },
            { text: "Full calculation of your tax bill for you to review and approve" },
            { text: "Instant submission to HMRC" },
            { text: "TaxZap fee can be claimed as an expense next year" },
            { text: "Expert accountant review & filing done for you" },
        ],
        isAvailable: true,
    },
];
